import React from 'react';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/core';

export const ActionModal = props => <Modal isCentered {...props} />;

export const ActionModalOverlay = ({ zIndex = 1900, ...props }) => (
  <ModalOverlay bg="rgba(20, 26, 32, 0.72)" zIndex={zIndex} {...props} />
);

export const ActionModalContent = ({ zIndex = 1901, maxWidth = '46rem', ...props }) => (
  <ModalContent
    zIndex={zIndex}
    maxWidth={{ base: 'calc(100vw - 1.5rem)', md: maxWidth }}
    maxHeight="calc(100vh - 2rem)"
    my={4}
    rounded="12px"
    border="1px solid"
    borderColor="rgba(31, 38, 44, 0.2)"
    boxShadow="0 30px 84px rgba(15, 20, 25, 0.5), 0 8px 26px rgba(15, 20, 25, 0.28)"
    overflow="hidden"
    {...props}
  />
);

export const ActionModalHeader = props => (
  <ModalHeader
    as="div"
    bg="darkGray"
    color="white"
    px={{ base: 5, md: 6 }}
    py={{ base: 4, md: 5 }}
    pr={{ base: '3.5rem', md: 16 }}
    borderBottom="1px solid"
    borderColor="rgba(255, 255, 255, 0.14)"
    {...props}
  />
);

export const ActionModalCloseButton = props => (
  <ModalCloseButton
    color="white"
    top={4}
    right={4}
    rounded="full"
    _hover={{ bg: 'rgba(255, 255, 255, 0.14)' }}
    _focus={{ shadow: 'outlineThin' }}
    {...props}
  />
);

export const ActionModalBody = props => (
  <ModalBody px={{ base: 5, md: 6 }} py={{ base: 5, md: 6 }} overflowY="auto" {...props} />
);

export const ActionModalFooter = props => (
  <ModalFooter
    px={{ base: 5, md: 6 }}
    py={4}
    borderTop="1px solid"
    borderColor="lightGray3"
    bg="white"
    {...props}
  />
);
